import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const FilterBar = ({ 
  dietaryFilter, 
  onDietaryFilterChange, 
  priceFilter, 
  onPriceFilterChange,
  sortBy,
  onSortChange,
  searchQuery,
  onSearchChange 
}) => {
  const dietaryOptions = [
    { value: 'all', label: 'All Items' },
    { value: 'vegetarian', label: 'Vegetarian' },
    { value: 'vegan', label: 'Vegan' },
    { value: 'gluten-free', label: 'Gluten Free' },
    { value: 'spicy', label: 'Spicy' }
  ];

  const priceOptions = [
    { value: 'all', label: 'All Prices' },
    { value: 'budget', label: 'Under 500 SSP' },
    { value: 'mid', label: '500-1000 SSP' },
    { value: 'premium', label: 'Above 1000 SSP' }
  ];

  const sortOptions = [
    { value: 'popular', label: 'Most Popular' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'name', label: 'Name: A to Z' }
  ];

  return (
    <section className="bg-card border-b border-border py-4 md:py-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" 
            />
            <input
              type="text"
              placeholder="Search menu items..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 md:py-3 bg-background border border-input rounded-lg text-sm md:text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>

          <Select
            options={dietaryOptions}
            value={dietaryFilter}
            onChange={onDietaryFilterChange}
            placeholder="Dietary Preferences"
          />

          <Select
            options={priceOptions}
            value={priceFilter}
            onChange={onPriceFilterChange}
            placeholder="Price Range"
          />

          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Sort By"
          />
        </div>
      </div>
    </section>
  );
};

export default FilterBar;